import React, {Suspense, useEffect, useState} from 'react'
import {LinearProgress} from '@mui/material';
import './App.css';
import {
    Routes,
    Route
} from "react-router-dom";
import routes from './Routes';
import '@identityd/cardauth'
import '@identityd/faceauth'
import {SDKContext} from "./contexts/SDKContext";
import {logEvent} from 'firebase/analytics';
import {analytics} from './lib/init-firebase';

function App() {

    const [progress, setProgress] = useState(0);
    const [page, setPage] = useState(0);
    const [activeStep, setActiveStep] = useState(0);
    const [rateFlag, setRateFlag] = useState(0);
    const [rateDialog, setRateDialog] = useState(true);
    const [emailDialog, setEmailDialog] = useState(false);
    const [cardImage, setCardImage] = useState('');
    const [firstName, setFirstName] = useState('');
    const [centerFace, setCenterFace] = useState('');
    const [ocrResults, setOcrResults] = useState([]);
    const [ocrImages, setOcrImages] = useState([]);
    const [facesCaptured, setFacesCaptured] = useState([]);
    const [enrollMatch, setEnrollMatch] = useState(0);
    const [cardMatch, setCardMatch] = useState(0);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [metadata, setMetadata] = useState();
    const [expired, setExpired] = useState(-1);
    const [lang, setLanguage] = useState('en');

    const openEmailDialog = () => {
        setEmailDialog(true);
    }
    const closeEmailDialog = () => {
        setEmailDialog(false);
    }

    const handleClose = () => {
        setRateDialog(false);
    }
    const handleOpen = () => {
        if (rateFlag === 0) {
            setRateDialog(true);
        }
    }

    const handleOBackdrop = () => {
        setOpenBackdrop(true)
    }
    const handleCBackdrop = () => {
        setOpenBackdrop(false)
    }

    const reset = () => {
        setMetadata(undefined);
        setFirstName('')
        setCardImage('')
        setCenterFace('');
        setOcrResults([]);
        setOcrImages([]);
        setFacesCaptured([]);
        setEnrollMatch(0);
        setCardMatch(0)
    }

    useEffect(() => {
        // const analytics = getAnalytics(app)
        logEvent(analytics, 'notification_received');
        console.log('logged event')
    }, [])

    return (
        <SDKContext.Provider value={{
            progress, setProgress,
            page, setPage,
            activeStep, setActiveStep,
            rateDialog, handleClose, handleOpen,
            emailDialog, openEmailDialog, closeEmailDialog,
            cardImage, setCardImage,
            firstName, setFirstName,
            centerFace, setCenterFace,
            ocrResults, SetOcrResults: setOcrResults,
            ocrimages: ocrImages, SetOcrImages: setOcrImages,
            facesCaptured, SetfacesCaptured: setFacesCaptured,
            enrollMatch, setEnrollMatch,
            cardMatch, setCardMatch,
            rateflag: rateFlag, setRateflag: setRateFlag, reset,
            openbackdrop: openBackdrop, handleOBackdrop, handleCBackdrop,
            metadata, setMetadata,
            expired, setexpired: setExpired,
            lang, setlang: setLanguage
        }}>
            <Suspense fallback={<LinearProgress color='inherit'/>}>
                <Routes>
                    {routes.map((r) => {
                        return <Route key={r.name} exact={r.exact} path={r.path} name={r.name} element={r.component}/>
                    })}
                </Routes>
            </Suspense>
        </SDKContext.Provider>
    );
}

export default App;
